export const qualificationState = {
  namespaced: true,

  state: () => ({
    qualification: {
      biddingLimit: 0,
      paddleNumber: "",
    },
    subscribed: false
  }),

  mutations: {
    REPLACE_QUALIFICATION(state, newData) {
      state.qualification = { ...newData }
    },

    SET_SUBSCRIBED(state, status) {
      state.subscribed = status
    },
  },

  actions: {
    updateQualificationCompletely({ commit }, newData) {
      commit("REPLACE_QUALIFICATION", newData)
    },

    reset({ commit }) {
      commit("REPLACE_QUALIFICATION", {
        biddingLimit: 0,
        paddleNumber: "",
      })
      commit("SET_SUBSCRIBED", false)
    }
  },

  getters: {
    qualification: state => state.qualification,
    isSubscribed: state => state.subscribed
  }
}
